import type { BreadcrumbItem } from '@components/display/breadcrumbs';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

interface BreadcrumbState {
    items: BreadcrumbItem[];
}

const initialState: BreadcrumbState = {
    items: [],
};

const breadcrumbSlice = createSlice({
    name: 'breadcrumb',
    initialState,
    reducers: {
        setBreadcrumbs: (state, action: PayloadAction<BreadcrumbItem[]>) => {
            state.items = action.payload;
        },
    },
});

const selectBreadcrumbs = (state: RootState) => state.breadcrumb.items;

export const { setBreadcrumbs } = breadcrumbSlice.actions;
export { selectBreadcrumbs };
export default breadcrumbSlice.reducer;
